import { documentHasElements } from "modules/dom";
import "./hero-scroll-container-block.scss";

documentHasElements(".js-hero-scroll-container-block", (heroScrollContainerBlocks) => {
    heroScrollContainerBlocks.forEach((heroScrollContainerBlock) => {

        const sliderBlocks = heroScrollContainerBlock.querySelector<HTMLElement>(".slider__blocks");
        const sliderBlocksChildren = heroScrollContainerBlock.querySelectorAll<HTMLDivElement>(".slider__blocks > div");

        const middleHeader = heroScrollContainerBlock.querySelector<HTMLElement>(".heading__middle");
        const sliderDots = heroScrollContainerBlock.querySelector<HTMLElement>(".slider__dots");

        sliderBlocksChildren.forEach((block: HTMLDivElement, index: number) => {
            block.setAttribute("data-item", index.toString());

            const title = block.querySelector<HTMLHeadingElement>("h2");
            const image = block.querySelector<HTMLElement>(".col.image");
            const clone = image?.cloneNode(true) as HTMLElement | null;

            // Replace image
            if (image) {
                image.remove();
            }

            const blockContainer = block.querySelector<HTMLElement>(".block");
            if (blockContainer && clone) {
                blockContainer.prepend(clone);
            }

            // Create list items for header and dots
            const listItem = document.createElement("li");
            const dotItem = document.createElement("li");

            if (index === 0) {
                listItem.classList.add("active");
                dotItem.classList.add("active");
            }

            listItem.setAttribute("data-item", index.toString());
            dotItem.setAttribute("data-item", index.toString());

            if (title) {
                listItem.innerHTML = title.innerHTML;
            }

            if (middleHeader) {
                middleHeader.appendChild(listItem);
            }

            sliderDots?.appendChild(dotItem);
        });

                
        sliderBlocks?.addEventListener("wheel", (e) => {
            const wheelEvent = e as WheelEvent;

            // Get the scroll direction
            const scrollDirection = wheelEvent.deltaY > 0 ? 'down' : 'up';

            const activeTab = heroScrollContainerBlock.querySelector<HTMLElement>(".slider__content.active");
            const nextTab = activeTab?.nextElementSibling as HTMLElement | null;
            const previousTab = activeTab?.previousElementSibling as HTMLElement | null;
            
            if (scrollDirection == 'down' && !activeTab?.classList.contains("last")) {
                e.preventDefault();
            }

            if (scrollDirection == 'up' && !activeTab?.classList.contains("first")) {
                e.preventDefault();
            }

            if (!sliderBlocks.classList.contains("delayed")) {
                const isScrollingDown = scrollDirection === "down";
                const isScrollingUp = scrollDirection === "up";

                const isAtEnd = activeTab?.classList.contains("last");
                const isAtStart = activeTab?.classList.contains("first");

                let targetTab = null;

                if (isScrollingDown && !isAtEnd) {
                    targetTab = nextTab;
                } else if (isScrollingUp && !isAtStart) {
                    targetTab = previousTab;
                }

                if (targetTab) {
                    // Remove current active states
                    heroScrollContainerBlock.querySelector(".heading__middle .active")?.classList.remove("active");
                    heroScrollContainerBlock.querySelector(".slider__dots .active")?.classList.remove("active");

                    // Get corresponding data-item and activate new elements
                    const sliderId = targetTab.getAttribute("data-item");

                    const headingItem = heroScrollContainerBlock.querySelector<HTMLElement>(`.heading__middle li[data-item="${sliderId}"]`);
                    const dotItem = heroScrollContainerBlock.querySelector<HTMLElement>(`.slider__dots li[data-item="${sliderId}"]`);

                    headingItem?.classList.add("active");
                    dotItem?.classList.add("active");

                    // Switch active content tab
                    activeTab?.classList.remove("active");
                    targetTab.classList.add("active");
                }

                // Add scroll delay
                sliderBlocks.classList.add("delayed");
                setTimeout(() => {
                    sliderBlocks.classList.remove("delayed");
                }, 500);
            }
                                       
            sliderBlocks.classList.add('delayed');
             
        }, { passive: false });
   
    });
});